import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { get } from 'lodash';


@inject('lineStore', 'dictStore', 'accountStore')
@observer
export default class Settings extends Component {

  state = {
    isOpen: 0
  }

  handleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  handleAgree = (agree) => {
    this.props.lineStore.basket.setAgreeWithCoefChanging(agree);
    this.props.accountStore.toggleAccountSettings('basketAgreeCf', agree);
  }

  handleClearAfterBet = () => {
    this.props.lineStore.basket.newBasketSetIsClearBasketAfterBet();
  }

  render() {
    const { mode, basketData } = this.props.lineStore.basket;
    const agreeWithCoefChange = get(basketData, 'agreeWithCoefChange')
    const isClearBasketAfterBet = get(basketData, 'isClearBasketAfterBet')
    const { getLang } = this.props.dictStore;

    return (
      <div className="basket-row basket-dropdown">
        <button className="basket-tuning-dropdown" onClick={this.handleOpen} >{getLang('SETTINGS_BASKET')}</button>
        {this.state.isOpen ?
          <div className="basket-tuning-dropdown__items">
            <div className="basket-tuning-dropdown__item">
              <div className="basket-dropdown-checkbox clearfix">
                <div className="basket-clear-after-bet-cont">
                  <div className={`checkbox ${isClearBasketAfterBet ? 'on' : ''}`} onClick={this.handleClearAfterBet}>
                    <span></span>
                    <label htmlFor="" className="basket-dropdown_text">{getLang('CLEAR_BASKET_AFTER_BET')}</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="basket-tuning-dropdown-coefficient">
              <div className="basket-tuning-dropdown_hr">
                <span className="basket-tuning-dropdown_hr-title">{getLang('BASKET_AGREE_CF')}</span>
              </div>
              <div className="basket-tuning-dropdown__item">
                <div className={`radio basket-agree-cf-radio basket-dropdown-checkbox ${agreeWithCoefChange == 0 ? 'on' : ''}`} onClick={() => this.handleAgree(0)}>
                  <span></span>
                  <label htmlFor="" className="basket-dropdown_text">{getLang('BASKET_AGREE_CF_0')}</label>
                </div>
              </div>
              <div className="basket-tuning-dropdown__item">
                <div className={`radio basket-agree-cf-radio basket-dropdown-checkbox ${agreeWithCoefChange == 1 ? 'on' : ''}`} onClick={() => this.handleAgree(1)}>
                  <span></span>
                  <label htmlFor="" className="basket-dropdown_text">{getLang('BASKET_AGREE_CF_1')}</label>
                </div>
              </div>
              <div className="basket-tuning-dropdown__item">
                <div className={`radio basket-agree-cf-radio basket-dropdown-checkbox ${agreeWithCoefChange == 2 ? 'on' : ''}`} onClick={() => this.handleAgree(2)}>
                  <span></span>
                  <label htmlFor="" className="basket-dropdown_text">{getLang('BASKET_AGREE_CF_2')}</label>
                </div>
              </div>
            </div>
          </div>
          : ''}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/basket/settings.js